import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import Button from "../../Button/Button";

// styles
import * as styles from "./OpenRoles.module.css";

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  isExternal: PropTypes.bool,
  onCtaClick: PropTypes.func,
};

const defaultProps = {
  title: "Explore Open Roles at Twin Health",
  description:
    "We're always looking for people who want to build meaningful healthcare solutions with us.",
  ctaText: "View Jobs on LinkedIn",
  ctaLink: "https://www.linkedin.com/company/twin-health-india/jobs/",
  isExternal: true,
  onCtaClick: () => {},
};

const OpenRoles = forwardRef(
  ({ title, description, ctaText, ctaLink, isExternal, onCtaClick }, ref) => {
    const { ref: inViewRef, inView } = useInView({
      triggerOnce: true,
      threshold: 0.3,
    });

    const handleCtaClick = e => {
      if (onCtaClick) {
        onCtaClick(e);
      }
    };

    return (
      <section id="open-roles" ref={ref} className={styles.openRolesWrapper}>
        <div
          ref={inViewRef}
          className={`container scroll_animate ${inView && "inview"}`}
        >
          <div className={styles.contentContainer}>
            {/* Title */}
            <h2 className={styles.title}>{title}</h2>

            {/* Description */}
            <p className={styles.description}>{description}</p>

            {/* CTA Button */}
            <div className={styles.ctaContainer}>
              <Button
                text={ctaText}
                href={ctaLink}
                isExternal={isExternal}
                variant="primary"
                onClick={handleCtaClick}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
);

OpenRoles.propTypes = propTypes;
OpenRoles.defaultProps = defaultProps;

export default OpenRoles;
